import { transferredFromLabel, UserId } from "@sp-crm/core";
import { AuthorName } from "components/byline/author-name";
import React from "react";

interface NoteAuthorProps {
    note: { authorId: UserId; transferBusinessName: string | null };
    authorPrefix: string;
}

export const NoteAuthor: React.FC<NoteAuthorProps> = ({ note, authorPrefix }) => {
    if (note.transferBusinessName) {
        return <span>{transferredFromLabel(note.transferBusinessName)}</span>;
    }
    return (
        <span>
            {authorPrefix}
            <AuthorName authorId={note.authorId} />
        </span>
    );
};
